import React from "react";

const Request = ({ handleChange, formInfo }) => {
  return (
    <div className="Request">
      <label htmlFor="requestInput">
        A request is an action you'd like the other party to take or agree to in
        order to meet the need you described above.
        <br></br>
        Be fair, clear, honest, and direct here.
      </label>
      <br></br>
      <textarea
        name="requestInput"
        placeholder="Moving forward, are you able to..."
        onChange={handleChange}
        value={formInfo.requestInput}
      ></textarea>
    </div>
  );
};

export default Request;
